// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"217":"be9bf815","650":"b0ba9279"}[chunkId] + ".chunk.js";
};